
<template>
  <v-dialog
    v-model="pValue"
    persistent
    :max-width="maxWidth"
    @update:model-value="onUpdate"
  >
    <v-card>
      <v-card-title class="headline">
        <v-icon v-if="icon" :color="type">
          {{ icon }}
        </v-icon>
        {{ title }}
      </v-card-title>
      <v-card-text>
        {{ message }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onCancel">{{ cancelText }}</v-btn>
        <v-btn color="primary" @click="onConfirm">{{ confirmText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  inheritAttrs: false,
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Confirmation",
    },
    icon: {
      type: String,
      default: "mdi-alert",
    },
    type: {
      type: String,
      default: "warning",
    },
    message: {
      type: String,
      default: "Are you sure you want to proceed?",
    },
    maxWidth: {
      type: String,
      default: "400px",
    },
    cancelText: {
      type: String,
      default: "Cancel",
    },
    confirmText: {
      type: String,
      default: "Confirm",
    },
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  data() {
    return {
      pValue: this.modelValue,
    };
  },
  watch: {
    modelValue(value) {
      this.pValue = value;
    },
  },
  methods: {
    onUpdate(value) {
      this.$emit("update:modelValue", value);
    },
    onCancel() {
      this.$emit("cancel");
      this.$emit("update:modelValue", false);
    },
    onConfirm() {
      this.$emit("confirm");
      this.$emit("update:modelValue", false);
    },
  },
};
</script>